<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='出科考核场次管理'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核日期：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.examdate" type="date" placeholder="选择日期" style="width: 100%;" value-format="yyyy/MM/dd"></el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <ZPGLSearchDictItemSelect v-model='condition.examtime' label='考核场次' :dictid='this.$utils.DictEnum.examtime'></ZPGLSearchDictItemSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url="searchUrl" ref="btnSearch"></SearchButton>
          <!-- <ImportButton></ImportButton> -->
          <AddButton url="/system/outapply/examtimedisabledadd"></AddButton>
        </div>
        <!--end: Search Form -->
      </div>
      <div class="m-portlet__body">
        <el-table :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="" label="禁用日期">
            <template slot-scope="scope">
              {{scope.row.ExamDate|formatFullDate}}
            </template>
          </el-table-column>
          <el-table-column prop="ExamTimeName" label="禁用场次">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: #F56C6C;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ExamTimeManage',
    data() {
      return {
        condition: {
          token: '',
          examdate: '',
          examtime: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/LoadExamTimeDisableList',
        tableData: [],
        fullscreenLoading: false
      }
    },
    filters: {
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pagesize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Delete: function(row) {
        var now = new Date(row.ExamDate)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        var date = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
        
        this.$confirm('确定删除 ' + date + ' ' + row.ExamTimeName + ' 的禁用限制?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          var that = this
          var args = {
            token: this.condition.token,
            id: row.ID
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/DeleteExamTimeDisable', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                that.$message({
                  message: '删除成功',
                  type: 'success'
                })
                that.$refs.btnSearch.Search()
              } else {
                that.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              that.fullscreenLoading = false
            })
            .catch(err => {
              console.log(err)
              that.$message({
                message: '删除失败',
                type: 'error'
              })
              that.fullscreenLoading = false
            })
        }).catch(() => {})
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
